import { defineStore, skipHydrate } from "pinia";
import type { VpcEntity } from "~/generated-api-client";

export const useVpcStore = defineStore("vpc", () => {

  const vpcs = ref<VpcEntity[]>([]);

  async function getAllVpcs() {
    const { $mwApi } = useNuxtApp();
    return $mwApi.getAllVpcs().then((res) => {
      vpcs.value = res.data;
      return res.data;
    }).catch(error => {
      console.error('Error fetching VPCs:', error);
      throw error;
    });
  }

  async function getVpcVms(vpcId: number) {
    const { $mwApi } = useNuxtApp();
    return $mwApi.getVpcVms(vpcId).then((res) => {
      return res.data;
    });
  }

  async function updateVpcVms(
    vpcId: number,
    vms: number[],
    restart: boolean = false,
    vmPrivateIps?: { vm_id: number; private_ip?: string }[],
  ) {
    const { $mwApi } = useNuxtApp();
    return $mwApi.updateVpcVms({
      vpc_id: vpcId,
      vm_id: vms,
      restart: restart,
      ...(vmPrivateIps ? { vm_private_ips: vmPrivateIps } : {}),
    }).then((res) => {
      return res.data;
    });
  }

  return {
    vpcs: vpcs,
    getAllVpcs,
    getVpcVms,
    updateVpcVms,
  };
});
